export const joinWithDelimiter = (
  labels: string[],
  delimiter: string = ' · ',
) =>
  labels
    .filter(Boolean)
    .map((label, index, array) =>
      index === array.length - 1 ? label : `${label}${delimiter}`,
    )
    .join('')
